import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationInputClass;
function SaveSlackIntegrationInput() {
  if (SaveSlackIntegrationInputClass === VOID) {
    class $ {
      constructor(partyId, team, channel) {
        this.f6s_1 = partyId;
        this.g6s_1 = team;
        this.h6s_1 = channel;
      }
      toString() {
        return 'SaveSlackIntegrationInput(partyId=' + this.f6s_1.toString() + ', team=' + this.g6s_1 + ', channel=' + this.h6s_1 + ')';
      }
      hashCode() {
        var result = this.f6s_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h6s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationInput()))
          return false;
        if (!this.f6s_1.equals(other.f6s_1))
          return false;
        if (!(this.g6s_1 === other.g6s_1))
          return false;
        if (!(this.h6s_1 === other.h6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationInput');
    SaveSlackIntegrationInputClass = $;
  }
  return SaveSlackIntegrationInputClass;
}
//region block: exports
export {
  SaveSlackIntegrationInput as SaveSlackIntegrationInput3jeifrdutkqgi,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationInput.mjs.map
